import * as React from 'react';
import { Season } from 'src/store/season/types';

import './Season.scss';
import { connect } from 'react-redux';
import { toggleSeason } from 'src/store/season/actions';
import { Section } from 'src/store/sections/types';

interface Props {
  season: Season;
  section: Section;
  style?: React.CSSProperties;
}

interface PropsFromDispatch {
  toggleSeason: typeof toggleSeason;
}

type AllProps = Props & PropsFromDispatch;

class SeasonComponent extends React.Component<AllProps> {
  constructor(props: AllProps) {
    super(props);

    this.onSeasonClick = this.onSeasonClick.bind(this);
  }

  public render() {
    const { season } = this.props;
    return (
      <div onClick={this.onSeasonClick} className={'season-item'}>
        <div className="title">
          <span>{season.title}</span>
        </div>
      </div>
    );
  }

  private onSeasonClick() {
    this.props.toggleSeason(this.props.section.title, this.props.season.id);
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  toggleSeason: (sectionTitle: string, id: number) => dispatch(toggleSeason(sectionTitle, id))
});

export default connect(
  null,
  mapDispatchToProps
)(SeasonComponent);



// WEBPACK FOOTER //
// ./src/components/Season/Season.tsx